module.exports = __webpack_public_path__ + "img/full1-min.1460a1c9.png";